// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Hooks = require("../../../utils/Hooks.bs.js");
var React = require("react");
var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var TipBoxes = require("../../../reason/clients/components/TipBoxes.bs.js");
var DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
var CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
var Form__Checkbox = require("../../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
var ReactDatepicker = require("../../../uikit/atoms/Datepicker/ReactDatepicker.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var TogglesGroup__Jsx3 = require("../../../uikit/reason/molecules/TogglesGroup/TogglesGroup__Jsx3.bs.js");
var CssGrid = require("components/CssGrid");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardRelayMLSTiming_draft_graphql = require("../../../__generated__/PropertyWizardRelayMLSTiming_draft_graphql.bs.js");
var PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
var PropertyWizardRelayMLSTiming_formState_graphql = require("../../../__generated__/PropertyWizardRelayMLSTiming_formState_graphql.bs.js");

var convertFragment = PropertyWizardRelayMLSTiming_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayMLSTiming_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayMLSTiming_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment_mlsListingTypeV5_decode = PropertyWizardRelayMLSTiming_draft_graphql.Utils.mlsListingTypeV5_decode;

var DraftFragment_mlsListingTypeV5_fromString = PropertyWizardRelayMLSTiming_draft_graphql.Utils.mlsListingTypeV5_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  mlsListingTypeV5_decode: DraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: DraftFragment_mlsListingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayMLSTiming_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment_localDraftMlsStatus_decode = PropertyWizardRelayMLSTiming_formState_graphql.Utils.localDraftMlsStatus_decode;

var FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardRelayMLSTiming_formState_graphql.Utils.localDraftMlsStatus_fromString;

var FormStateFragment = {
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function getOptionLabel(x) {
  switch (x) {
    case "ACTIVE" :
        return "Yes, I'm adding to the MLS as Active (won't be added to MLS as Coming Soon)";
    case "COMING_SOON" :
        return "Yes, I'm adding to the MLS as a Coming Soon";
    case "OFF_MLS" :
        return "No, I have no MLS plans in the next month";
    
  }
}

var $$Option = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionLabel
};

var options = [
  "ACTIVE",
  "COMING_SOON",
  "OFF_MLS"
];

var SelectWithComingSoon = {
  $$Option: $$Option,
  options: options
};

function getOptionLabel$1(x) {
  if (x === "yes") {
    return "Yes";
  } else {
    return "No";
  }
}

var $$Option$1 = {
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionLabel$1
};

var options$1 = [
  "yes",
  "no"
];

var SelectYesOrNo = {
  $$Option: $$Option$1,
  options: options$1
};

function PropertyWizardRelay__MLSTiming(props) {
  var match = PropertyWizardFormRelay.Context.use();
  var draft = use(props.draft);
  var draftProperty = draft.draftProperty;
  var formState = use$1(props.formState);
  var stepHasBeenTouched = formState.stepMlsTimingTouched;
  var comingSoonEnabled = draft.chapterPreferenceMlsComingSoonActivated;
  var willShow = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.willShow = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draftProperty.willShow, PropertyWizardFormRelay__Validators__MLSTiming.WillShow.useIsValid());
  var willAcceptOffers = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.willAcceptOffers = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draftProperty.willAcceptOffers, PropertyWizardFormRelay__Validators__MLSTiming.WillAcceptOffers.useIsValid());
  var onMlsAtValid = PropertyWizardFormRelay__Validators__MLSTiming.OnMLSAt.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  var tmp;
  if (onMlsAtValid !== undefined) {
    if (typeof onMlsAtValid === "object") {
      var e = onMlsAtValid.VAL;
      tmp = {
        NAME: "Error",
        VAL: e === "required" ? "is required" : (
            e === "alreadyOnMlsAndAfterToday" ? "must be before today when the property is already on MLS" : "must be after today"
          )
      };
    } else {
      tmp = "Valid";
    }
  } else {
    tmp = undefined;
  }
  var onMlsAt = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.onMlsAt = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draftProperty.onMlsAt, tmp);
  var mlsListingTypeValid = PropertyWizardFormRelay__Validators__MLSTiming.MLSListingType.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  var tmp$1;
  if (mlsListingTypeValid !== undefined) {
    if (typeof mlsListingTypeValid === "object") {
      var e$1 = mlsListingTypeValid.VAL;
      tmp$1 = {
        NAME: "Error",
        VAL: e$1 === "alreadyOnMlsAndNotActive" ? "property is already on the MLS and therefore must be set as Active on MLS" : (
            e$1 === "required" ? "is required" : "property is already on the MLS. You must either not change this, or set it to Active on MLS"
          )
      };
    } else {
      tmp$1 = "Valid";
    }
  } else {
    tmp$1 = undefined;
  }
  var mlsListingType = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.mlsListingType = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draftProperty.mlsListingType, tmp$1);
  var previousMlsListingType = Hooks.usePrevious(mlsListingType.value);
  React.useEffect((function () {
          if (previousMlsListingType !== mlsListingType.value) {
            var match = mlsListingType.value;
            var exit = 0;
            if (match !== undefined) {
              switch (match) {
                case "COMING_SOON" :
                    willShow.onChange(false);
                    willAcceptOffers.onChange(false);
                    break;
                case "ACTIVE" :
                case "OFF_MLS" :
                    exit = 1;
                    break;
                
              }
            }
            if (exit === 1) {
              willShow.onChange(true);
              willAcceptOffers.onChange(true);
            }
            
          }
          
        }), [
        mlsListingType.value,
        previousMlsListingType
      ]);
  var tmp$2;
  if (comingSoonEnabled) {
    var match$1 = mlsListingType.status;
    tmp$2 = JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
          getOptionLabel: getOptionLabel,
          getOptionValue: getOptionLabel,
          onBlur: (function (param) {
              mlsListingType.onBlur();
            }),
          onChange: mlsListingType.onChange,
          options: options,
          value: mlsListingType.value,
          status: match$1 !== undefined ? (
              match$1 === "ok" ? "Success" : "Failure"
            ) : "Neutral"
        });
  } else {
    var match$2 = mlsListingType.value;
    var tmp$3;
    if (match$2 !== undefined) {
      switch (match$2) {
        case "ACTIVE" :
            tmp$3 = "yes";
            break;
        case "COMING_SOON" :
            tmp$3 = undefined;
            break;
        case "OFF_MLS" :
            tmp$3 = "no";
            break;
        
      }
    } else {
      tmp$3 = undefined;
    }
    var match$3 = mlsListingType.status;
    tmp$2 = JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
          getOptionLabel: getOptionLabel$1,
          getOptionValue: getOptionLabel$1,
          onBlur: (function (param) {
              mlsListingType.onBlur();
            }),
          onChange: (function (value) {
              mlsListingType.onChange(value !== undefined ? (
                      value === "yes" ? "ACTIVE" : "OFF_MLS"
                    ) : undefined);
            }),
          options: options$1,
          value: tmp$3,
          status: match$3 !== undefined ? (
              match$3 === "ok" ? "Success" : "Failure"
            ) : "Neutral"
        });
  }
  var match$4 = draftProperty.mlsListingType;
  var tmp$4;
  var exit = 0;
  if (match$4 !== undefined) {
    switch (match$4) {
      case "ACTIVE" :
      case "COMING_SOON" :
          exit = 1;
          break;
      case "OFF_MLS" :
          tmp$4 = null;
          break;
      
    }
  } else {
    tmp$4 = null;
  }
  if (exit === 1) {
    var match$5 = draftProperty.mlsListingType;
    var tmp$5;
    if (match$5 !== undefined) {
      switch (match$5) {
        case "COMING_SOON" :
            tmp$5 = "Date planned to go Active on MLS";
            break;
        case "ACTIVE" :
        case "OFF_MLS" :
            tmp$5 = "Approximate MLS date";
            break;
        
      }
    } else {
      tmp$5 = "Approximate MLS date";
    }
    var match$6 = formState.mlsStatus;
    var tmp$6;
    var exit$1 = 0;
    switch (match$6) {
      case "OnMls" :
      case "OnMlsButAllowed" :
          tmp$6 = undefined;
          break;
      default:
        var tmp$7 = match.mode;
        if (typeof tmp$7 !== "object") {
          exit$1 = 2;
        } else {
          switch (tmp$7.TAG) {
            case "Edit" :
            case "Rebroadcast" :
                tmp$6 = undefined;
                break;
            case "BroadcastQuietSeller" :
                exit$1 = 2;
                break;
            
          }
        }
    }
    if (exit$1 === 2) {
      tmp$6 = Caml_option.some(CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone)));
    }
    var match$7 = formState.mlsStatus;
    var tmp$8;
    var exit$2 = 0;
    switch (match$7) {
      case "OnMls" :
      case "OnMlsButAllowed" :
          exit$2 = 2;
          break;
      default:
        tmp$8 = undefined;
    }
    if (exit$2 === 2) {
      tmp$8 = Caml_option.some(CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone)));
    }
    tmp$4 = JsxRuntime.jsxs(CssGrid.Cell, {
          width: 12,
          widthMd: 3,
          children: [
            JsxRuntime.jsx(Form__Label.make, {
                  labelText: tmp$5
                }),
            JsxRuntime.jsx(ReactDatepicker.make, {
                  placeholderText: "Approximate date",
                  onChange: (function (v) {
                      onMlsAt.onChange(v);
                    }),
                  selected: draftProperty.onMlsAt,
                  minDate: tmp$6,
                  maxDate: tmp$8,
                  status: onMlsAt.status
                }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
                  valid: onMlsAt.valid
                })
          ]
        });
  }
  var match$8 = draftProperty.propertyType;
  var tmp$9;
  tmp$9 = match$8 === "FOR_SALE" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(Form__Checkbox.make, {
                  onChange: (function (evt) {
                      var checked = evt.target.checked;
                      willShow.onChange(checked);
                    }),
                  checked: Core__Option.getOr(willShow.value, false),
                  disabled: false,
                  label: "Will show prior to MLS",
                  mobileStyles: true
                }),
            JsxRuntime.jsx(Form__Checkbox.make, {
                  onChange: (function (evt) {
                      var checked = evt.target.checked;
                      willAcceptOffers.onChange(checked);
                    }),
                  checked: Core__Option.getOr(willAcceptOffers.value, false),
                  disabled: false,
                  label: "Will accept offers prior to MLS",
                  mobileStyles: true
                })
          ]
        }) : null;
  return JsxRuntime.jsxs(FormV5.FormSection.make, {
              tipbox: Caml_option.some(JsxRuntime.jsx(TipBoxes.PropertyWizard.MlsTimingWithComingSoon.make, {
                        offMlsConfigurable: true
                      })),
              children: [
                JsxRuntime.jsx(Form__Label.make, {
                      labelText: "Are you putting the property on the MLS in the next month?"
                    }),
                tmp$2,
                JsxRuntime.jsx(Form__Components.FieldError.make, {
                      valid: mlsListingType.valid
                    }),
                JsxRuntime.jsx(View__Jsx3.make, {
                      mt: "md",
                      children: Caml_option.some(tmp$4)
                    }),
                JsxRuntime.jsx(View__Jsx3.make, {
                      mt: "md",
                      children: Caml_option.some(JsxRuntime.jsx(TogglesGroup__Jsx3.make, {
                                children: tmp$9
                              }))
                    })
              ]
            });
}

var Components;

var FormSection;

var Validators;

var FormUtils;

var Cell;

var TipBoxes$1;

var make = PropertyWizardRelay__MLSTiming;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Cell = Cell;
exports.TipBoxes = TipBoxes$1;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.SelectWithComingSoon = SelectWithComingSoon;
exports.SelectYesOrNo = SelectYesOrNo;
exports.make = make;
/* Hooks Not a pure module */
